var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.75 4.25 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1921 5H9.80807C8.65914 5.00635 7.5598 5.46885 6.75189 6.28576C5.94398 7.10268 5.49368 8.20708 5.50007 9.356V14.644C5.49368 15.7929 5.94398 16.8973 6.75189 17.7142C7.5598 18.5311 8.65914 18.9937 9.80807 19H15.1921C16.341 18.9937 17.4403 18.5311 18.2482 17.7142C19.0562 16.8973 19.5064 15.7929 19.5001 14.644V9.356C19.5064 8.20708 19.0562 7.10268 18.2482 6.28576C17.4403 5.46885 16.341 5.00635 15.1921 5Z",
    stroke: "rgba(100,21,255,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1841 10.5291H16.5301V13.8641",
    stroke: "rgba(100,21,255,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5301 10.5291L12.3301 14.8491C11.9623 15.2167 11.374 15.241 10.9771 14.9051L10.0771 14.1401C9.86727 13.9618 9.59323 13.8779 9.31957 13.9082C9.04591 13.9384 8.79684 14.0802 8.63108 14.3001C8.59208 14.3521 8.55408 14.4051 8.51008 14.4531L6.18408 17.0001",
    stroke: "rgba(100,21,255,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.f6fe6669f1464ce188bfc009c34aacc3.svg";
export { ForwardRef as ReactComponent };